import { useUserInfo } from '@/store/userStore';
import { getNavigationLabel } from '@/utils/navigation-label';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { KeepAliveTab } from '../types';

export function useTabLabelRender() {
  const { t } = useTranslation();
  const { role } = useUserInfo();

  const specialTabRenderMap = useMemo<Record<string, (tab: KeepAliveTab) => React.ReactNode>>(
    () => ({
      'sys.menu.system.user_detail': (tab: KeepAliveTab) => {
        return t(tab.label);
      },
    }),
    [t],
  );

  const renderTabLabel = (tab: KeepAliveTab) => {
    const specialRender = specialTabRenderMap[tab.label];
    if (specialRender) {
      return specialRender(tab);
    }
    return getNavigationLabel(tab.label, t, role);
  };

  return renderTabLabel;
}
